import React from 'react';
import PropTypes from 'prop-types';
import {contentUtils, HTMLContent} from "mindsets-js-sdk";

function DnDDroppableItem({item}) {
    function getItemStyle() {
        return {
            ...item.item_position
        }
    }

    function getDroppableStyle() {
        return {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "72px",
            minHeight: "72px",
            padding: "10px",
            borderRadius: "4px",
            position: "relative",
            ..._.get(item, 'droppable_style')
        };
    }

    function renderSelected() {
        if (item.placeholder) {
            return (
                <div>
                    <HTMLContent html_str={contentUtils.processStringContent(item.placeholder)}/>
                </div>
            );
        } else {
            return undefined;
        }
    }

    return (
        <div className="cc-dndpuzzle-layout-item" style={getItemStyle()}>
            <div style={getDroppableStyle()}>
                {renderSelected()}
            </div>
        </div>
    );
}

DnDDroppableItem.propTypes = {
    item: PropTypes.shape({
        dnd_id: PropTypes.string.isRequired,
        placeholder: PropTypes.string
    }).isRequired
}

export default DnDDroppableItem
